import React from 'react';
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();

  return (
    <div className="z-10 relative pt-[80px] xl:pt-[140px]">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
        <div className="bg-[#277423] pb-[30px] flex flex-col items-center">
          <p className="text-center host-grotesk mt-[40px] xl:mt-[60px] text-white text-[14px] xl:text-[16px]">{t('footer.4')}</p>
          <p className="text-white mt-[10px] text-[32px] sm:text-[40px] xl:text-[64px] host-grotesk leading-[1.2] text-center">{t('footer.7')}</p>

          <div className="mt-[40px] xl:mt-[60px] flex flex-col items-center gap-[6px]">
            <div className="flex items-center gap-[8px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M11.5 1.5H0.5V2.915L6 5.69L11.5 2.9145V1.5Z" fill="white"/>
                <path d="M11.5 4.03467L6 6.81017L0.5 4.03517V10.5002H11.5V4.03467Z" fill="white"/>
              </svg>
              <p className="PtRoot text-[12px] xl:text-[14px] text-[#FFFFFF] font-[700]">support@revacy.pro</p>
            </div>
            {/* <div className="flex items-center gap-[8px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="#FFFFFFB2">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
              </svg>
              <p className="PtRoot text-[12px] xl:text-[14px] text-[#FFFFFFB2]">1111111111</p>
            </div>
            <div className="flex items-center gap-[8px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="#FFFFFFB2">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
              </svg>
              <p className="PtRoot text-[12px] xl:text-[14px] text-[#FFFFFFB2]">1111111111</p>
            </div> */}
            <p className="PtRoot text-[12px] xl:text-[14px] text-[#FFFFFFB2] text-center mt-[4px] mx-[20px] max-w-[500px]">{t('footer.11')}</p>
          </div>

          <a href="/terms.pdf">
            <p className="pt-[30px] xl:pt-[40px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] PtRoot font-[700]">{t('footer.5')}</p>
          </a>
          <p className="pt-[12px] text-[#FFFFFF80] text-[12px] xl:text-[14px] PtRoot text-center mx-[20px]">{t('footer.6')}</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
